import React from 'react';
import Grid from '@mui/material/Grid';
import FilteredSchemaSelectContainer from './FilteredSchemaSelectContainer';
import ServerSelectContainer from './ServerSelectContainer';

const SelectServerSchemaContainer = () => {

  return (
    <Grid
      container
      spacing={3}
      display="flex"
      justifyContent="center"
      style={{ margin: '100px auto' }}
    >
      <Grid item xs={12} md={4}>
        <ServerSelectContainer />
      </Grid>
      <Grid item xs={12} md={4}>
        <FilteredSchemaSelectContainer />
      </Grid>
    </Grid>
  );
}

export default SelectServerSchemaContainer;
